import * as React from "react";
import { Button } from "primereact/button";
import { ProgressBar } from "primereact/progressbar";
import { Alert } from "reactstrap";

export default function PositionWaiting({ display, onRefresh }) {
    if (!display) return null;

    return (
        <Alert color="info" title="In attesa di rilevare il dispositivo">
            <div>
                <div>
                    <ProgressBar className="mb-2" mode="indeterminate" style={{ height: "8px" }} />
                </div>
                <p>
                    Accendere il veicolo ed attendere. In caso di attesa prolungata svegliare il dispositivo con il bottone "Sveglia dispositivo"
                </p>
                <div>
                    <Button
                        className="p-button"
                        type="button"
                        label="Sveglia dispositivo"
                        onClick={onRefresh}
                        icon="pi pi-refresh pi-spin"
                    />
                </div>
            </div>
        </Alert>
    );
}
